/* eslint-disable react/prop-types */
import React, { Component } from "react";
import { Page, Text, View, Document, StyleSheet, Image, Font } from "@react-pdf/renderer";
import Constants from "utilities/Constants";
import Strings from "utilities/StringSelector";
import Utils from "utilities/Utils";

// Register Roboto Font
Font.register({ family: "RobotoRegular", src: `${process.env.PUBLIC_URL}/fonts/roboto-v20-latin-regular.ttf` });
Font.register({ family: "RobotoMedium", src: `${process.env.PUBLIC_URL}/fonts/Roboto-Medium.ttf` });

const UtilsInstance = new Utils();

export class AnalyzerDPReport extends Component {
  constructor(props) {
    super(props);

    this.state = {
      generatingDate: new Date(),
      // Summary
      scopeFirstLiveListPage: -1,
      scopeFirstOscilloscopePage: -1,
      scopeFirstBarGraphPage: -1,
      scopeFirstLogPage: -1,
      // Summary numbering control
      isFirstScopeLiveListPage: true,
      isFirstScopeOscilloscopePage: true,
      isFirstScopeBarGraphPage: true,
      isFirstScopeLogPage: true,
    };
  }

  // ------------------------ Utilities -------------------------
  getDateNow = () => {
    return (
      this.state.generatingDate.getDate()
      + "/"
      + (this.state.generatingDate.getMonth() + 1)
      + "/"
      + this.state.generatingDate.getFullYear()
    );
  }

  getRectImage = (isFilled) => {
    if (isFilled) {
      return <Image src={`${process.env.PUBLIC_URL}/images/filled-rect.png`} style={generalInfoStyles.rectangle} />;
    }
    else {
      return <Image src={`${process.env.PUBLIC_URL}/images/empty-rect.png`} style={generalInfoStyles.rectangle} />;
    }
  }

  whenWasTurnedOnAsDate = (uptimeInSeconds) => {
    if (uptimeInSeconds !== undefined) {
      const uptimeInMillis = uptimeInSeconds * 1000;
      const timeNow = new Date().getTime();
      const whenWasTurnedOn = timeNow - uptimeInMillis;
      const dateWhenWasTurnedOn = new Date(whenWasTurnedOn);
      return dateWhenWasTurnedOn;
    }
  }

  getDateTimeNow = () => {
    let year = this.state.generatingDate.getFullYear();
    let month = this.state.generatingDate.getMonth() + 1;
    let day = this.state.generatingDate.getDate();
    let hour = this.state.generatingDate.getHours();
    let minutes = this.state.generatingDate.getMinutes();
    let seconds = this.state.generatingDate.getSeconds();

    if (day < 10) { day = "0" + day; }
    if (month < 10) { month = "0" + month; }
    if (hour < 10) { hour = "0" + hour; }
    if (minutes < 10) { minutes = "0" + minutes; }
    if (seconds < 10) { seconds = "0" + seconds; }

    return (day + "/" + month + "/" + year + " " + hour + ":" + minutes + ":" + seconds);
  }

  getBaudRateText = (baudRate) => {
    const lang = localStorage.getItem(Constants.LOCAL_STORAGE_KEY);

    let baudRateKbps = (baudRate / 1000);
    let baudRateMbps = (baudRate / 1000000);

    let baudRateKbpsText = baudRateKbps.toString();
    let baudRateMbpsText = baudRateMbps.toString();

    if (lang !== Constants.EN_LANG_KEY) {
      baudRateKbpsText = UtilsInstance.replacePointWithComma(baudRateKbpsText);
      baudRateMbpsText = UtilsInstance.replacePointWithComma(baudRateMbpsText);
    }

    // If the baud rate is greater then 1000 Kbps show it as Mbps
    if (baudRateKbps >= 1000.00) {
      return baudRateMbpsText + " Mbps";
    }
    else {
      return baudRateKbpsText + " Kbps";
    }
  }

  getTensaoIdleText = (tensaoIdle) => {
    const lang = localStorage.getItem(Constants.LOCAL_STORAGE_KEY);

    let tensaoIdleText = tensaoIdle.toFixed(2);

    if (lang !== Constants.EN_LANG_KEY) {
      tensaoIdleText = UtilsInstance.replacePointWithComma(tensaoIdleText);
    }

    return tensaoIdleText + " " + Strings.VOLTAGE_PEAK_TO_PEAK;
  }

  getAmplitudeText = (device) => {
    const lang = localStorage.getItem(Constants.LOCAL_STORAGE_KEY);

    if (lang !== Constants.EN_LANG_KEY) {
      return UtilsInstance.replacePointWithComma(device.amplitude.toFixed(2)) + Strings.VOLTAGE_PEAK_TO_PEAK;
    }
    else {
      return device.amplitude.toFixed(2) + Strings.VOLTAGE_PEAK_TO_PEAK;
    }
  }

  getAmplitudeMinText = (device) => {
    const lang = localStorage.getItem(Constants.LOCAL_STORAGE_KEY);

    if (lang !== Constants.EN_LANG_KEY) {
      return UtilsInstance.replacePointWithComma(device.amplitudeMin.toFixed(2)) + Strings.VOLTAGE_PEAK_TO_PEAK;
    }
    else {
      return device.amplitudeMin.toFixed(2) + Strings.VOLTAGE_PEAK_TO_PEAK;
    }
  }

  getSlaveMasterText = (isMaster) => {
    if (isMaster) {
      return Strings.MASTER_DP;
    }
    else {
      return Strings.SLAVE_DP;
    }
  }

  getStatusText = (status) => {
    if (status === Constants.GOOD) {
      return Strings.GOOD_STRING;
    }
    else if (status === Constants.ATTENTION) {
      return Strings.ATTENTION_STRING;
    }
    else if (status === Constants.BAD) {
      return Strings.BAD_STRING;
    }
    else {
      return Strings.UNKNOWN_STRING;
    }
  }

  getResponseTimeValue = (responseTime) => {
    if (responseTime !== undefined && responseTime !== null && responseTime !== "-") {
      const lang = localStorage.getItem(Constants.LOCAL_STORAGE_KEY);

      if (lang !== Constants.EN_LANG_KEY) {
        return UtilsInstance.replacePointWithComma(responseTime.toFixed(2)) + Strings.MICROSSECOND;
      }
      else {
        return responseTime.toFixed(2) + Strings.MICROSSECOND;
      }
    }
    else {
      return responseTime;
    }
  }

  // ----------------- Header for all the pages -----------------
  getPageHeader = () => {
    return (
      <View fixed>
        <View style={headerStyles.container}>
          <Image src={`${process.env.PUBLIC_URL}/logo_report.png`} style={headerStyles.logo} />
          <Text style={headerStyles.text}>{Strings.HEADER_TEXT_DP}</Text>
        </View>
        <View style={headerStyles.line}></View>
      </View>
    );
  }

  // ----------------- Footer for all the pages -----------------
  getPageFooter = (reportPart) => {
    return (
      <View style={footerStyles.container} fixed>
        <View style={footerStyles.line}></View>
        <View>
          <Text style={footerStyles.text} render={({ pageNumber, totalPages }) => {
            this.setFirstPageNumbers(reportPart, pageNumber);
            return `${this.getDateNow()}, ${Strings.PAGE} ${pageNumber} / ${totalPages}`;
          }} fixed />
        </View>
      </View>
    );
  }

  setFirstPageNumbers = (reportPart, pageNumber) => {
    if (reportPart === "scopeLiveList" && this.state.isFirstScopeLiveListPage) {
      console.log(reportPart, pageNumber);
      this.setState({
        scopeFirstLiveListPage: pageNumber,
        isFirstScopeLiveListPage: false
      });
    }
    else if (reportPart === "scopeOscilloscope" && this.state.isFirstScopeOscilloscopePage) {
      console.log(reportPart, pageNumber);
      this.setState({
        scopeFirstOscilloscopePage: pageNumber,
        isFirstScopeOscilloscopePage: false
      });
    }
    else if (reportPart === "scopeBarGraph" && this.state.isFirstScopeBarGraphPage) {
      console.log(reportPart, pageNumber);
      this.setState({
        scopeFirstBarGraphPage: pageNumber,
        isFirstScopeBarGraphPage: false
      });
    }
    else if (reportPart === "scopeLog" && this.state.isFirstScopeLogPage) {
      console.log(reportPart, pageNumber);
      this.setState({
        scopeFirstLogPage: pageNumber,
        isFirstScopeLogPage: false
      });
    }
  }

  // ----------------- Generate Report --------------------------
  createReport = () => {
    return (
      <Document
        title={Strings.REPORT_EXPORT_NAME_DP}>
        {this.createGeneralInfoPage()}
        {this.createDataInfoPage()}
        {this.createSummaryPage()}
        {this.createLiveListPages()}
        {this.createOscilloscopePages()}
        {this.createBarGraphPages()}
        {this.createMonitoringLogPages()}
        {this.createDisclaimerPage()}
      </Document>
    );
  }

  // ----------------- General Information ---------------------
  createGeneralInfoPage = () => {
    return (
      <Page
        size="A4"
        orientation="portrait"
        wrap={true}
        style={reusableStyles.page}>

        {this.getPageHeader()}

        <Text style={reusableStyles.pageTitle}>{Strings.GENERAL_REPORT}</Text>

        <Text style={reusableStyles.subHeaderText}>{Strings.CLIENT_INFO}</Text>

        <View style={reusableStyles.subHeaderLine} />

        <View style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center" }} >

          <View style={{ maxWidth: "400pt" }}>
            <Text style={reusableStyles.normalText}>{Strings.PROJECT_NAME} {this.props.userInput.clientProjectName}</Text>
            <Text style={reusableStyles.normalText}>{Strings.NETWORK_NAME} {this.props.userInput.clientNetworkName}</Text>
            <Text style={reusableStyles.normalText}>{Strings.LOCATION} {this.props.userInput.clientLocation}</Text>
            <Text style={reusableStyles.normalText}>{Strings.COMPANY_NAME} {this.props.userInput.clientCompanyName}</Text>
            <Text style={reusableStyles.normalText}>{Strings.ACCOUNTABLE_NAME} {this.props.userInput.clientAccountableName}</Text>
            <Text style={reusableStyles.normalText}>{Strings.COMPANY_ADDRESS} {this.props.userInput.clientAddress}</Text>
            <Text style={reusableStyles.normalText}>{Strings.COMPANY_CITY} {this.props.userInput.clientCity}</Text>
            <Text style={reusableStyles.lastInfoText}>{Strings.COMPANY_TEL} {this.props.userInput.clientTel}</Text>
          </View>

          <View style={{ maxWidth: "100pt" }}>
            {this.getClientImage()}
          </View>
        </View>

        <Text style={reusableStyles.subHeaderText}>{Strings.EXECUTING_COMPANY_INFO}</Text>

        <View style={reusableStyles.subHeaderLine} />

        <View style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center" }} >

          <View style={{ maxWidth: "400pt" }}>
            <Text style={reusableStyles.normalText}>{Strings.EXECUTING_COMPANY_NAME} {this.props.userInput.executingCompanyName}</Text>
            <Text style={reusableStyles.normalText}>{Strings.EXECUTING_ACCOUNTABLE_NAME} {this.props.userInput.executingAccountableName}</Text>
            <Text style={reusableStyles.normalText}>{Strings.EXECUTING_TEL} {this.props.userInput.executingTel}</Text>
            <Text style={reusableStyles.lastInfoText}>{Strings.EXECUTING_EMAIL} {this.props.userInput.executingEmail}</Text>
          </View>

          <View style={{ maxWidth: "100pt" }}>
            {this.getExecutorImage()}
          </View>
        </View>

        <Text style={reusableStyles.subHeaderText}>{Strings.ANNOTATIONS}</Text>

        <View style={reusableStyles.subHeaderLine} />

        <View style={generalInfoStyles.notesSection}>
          <Text style={reusableStyles.normalText}>{this.props.userInput.notes}</Text>
        </View>

        <Text style={reusableStyles.subHeaderText}>{Strings.CONCLUSION}</Text>

        <View style={reusableStyles.subHeaderLine} />

        <View style={generalInfoStyles.conclusionSection}>

          <View>

            <View style={generalInfoStyles.rectangleSection}>
              {this.getRectImage(this.props.userInput.conformity === Constants.CONFORM)}
              <Text style={reusableStyles.normalText}>{Strings.CONFORM}</Text>
            </View>

            <View style={generalInfoStyles.rectangleSection}>
              {this.getRectImage(this.props.userInput.conformity === Constants.CONFORM_W_RESTRICTION)}
              <Text style={reusableStyles.normalText}>{Strings.CONFORM_W_RESTRICTION}</Text>
            </View>

            <View style={generalInfoStyles.rectangleSection}>
              {this.getRectImage(this.props.userInput.conformity === Constants.NON_CONFORM)}
              <Text style={reusableStyles.normalText}>{Strings.NON_CONFORM}</Text>
            </View>

          </View>

          <View style={generalInfoStyles.signatureLine} />

        </View>

        {this.getPageFooter("")}

      </Page >
    );
  }

  getClientImage = () => {
    // Only try to draw the Image on the pdf if the user has
    // submited a client image
    if (this.props.userInput.clientImg !== "") {
      return (
        <Image style={{
          maxHeight: "100pt",
          width: "100pt"
        }} src={this.props.userInput.clientImg} />
      );
    }
  }

  getExecutorImage = () => {
    // Only try to draw the Image on the pdf if the user has
    // submited a executor image
    if (this.props.userInput.executorImg !== "") {
      return (
        <Image style={{
          maxHeight: "100pt",
          width: "100pt"
        }} src={this.props.userInput.executorImg} />
      );
    }
  }

  // ----------------- Data Information ------------------------
  createDataInfoPage = () => {
    return (
      <Page
        size="A4"
        orientation="portrait"
        wrap={true}
        style={reusableStyles.page}>

        {this.getPageHeader()}

        <Text style={reusableStyles.pageTitle}>{Strings.DATA_REPORT}</Text>

        <Text style={reusableStyles.subHeaderText}>{Strings.ANALYSIS_INFO}</Text>

        <View style={reusableStyles.subHeaderLine} />

        <Text style={reusableStyles.normalText}>{Strings.SEGMENT_TAG} {this.props.tag}</Text>
        <Text style={reusableStyles.normalText}>{Strings.ANALYZER_VERSION_STRING} {Constants.TS_MONITOR_VERSION}</Text>
        <Text style={reusableStyles.normalText}>{Strings.ANALYSIS_INIT} {UtilsInstance.getMonitorInitTime(this.props.uptime, UtilsInstance)} </Text>
        <Text style={reusableStyles.normalText}>{Strings.REPORT_GENERATION} {this.getDateTimeNow()} </Text>
        <Text style={reusableStyles.normalText}>{Strings.ANALYSIS_DURATION} {UtilsInstance.formatToRelativeTime2(this.props.uptime, UtilsInstance, Strings)} </Text>

        <Text style={reusableStyles.normalText}>{Strings.BAUD_RATE} {this.getBaudRateText(this.props.baudRate)}</Text>
        <Text style={reusableStyles.normalText}>{Strings.NUM_MASTERS} {this.props.masters}</Text>
        <Text style={reusableStyles.normalText}>{Strings.NUM_SLAVES} {this.props.slaves}</Text>
        <Text style={reusableStyles.normalText}>{Strings.AMPLITUDE_IDLE_1} {this.getTensaoIdleText(this.props.tensaoIdle)}</Text>

        <Text style={reusableStyles.secondSubHeaderText}>{Strings.ETHERNET_INFO}</Text>

        <View style={reusableStyles.subHeaderLine} />

        <Text style={reusableStyles.normalText}>{Strings.IP_DP}{this.props.configData.addr} </Text>
        <Text style={reusableStyles.normalText}>{Strings.MASK_DP}{this.props.configData.netmask} </Text>
        <Text style={reusableStyles.normalText}>{Strings.GATEWAY_DP}{this.props.configData.gateway} </Text>

        <Text style={reusableStyles.secondSubHeaderText}>{Strings.WLAN_INFO}</Text>

        <View style={reusableStyles.subHeaderLine} />

        <Text style={reusableStyles.normalText}>{Strings.NETWORK_NAME_DP}{this.props.wifiConfigData.wifiName}</Text>
        <Text style={reusableStyles.normalText}>{Strings.IP_DP}{this.props.wifiConfigData.wifiAddr}</Text>
        <Text style={reusableStyles.normalText}>{Strings.MASK_DP}{this.props.wifiConfigData.wifiNetmask}</Text>
        <Text style={reusableStyles.normalText}>{Strings.GATEWAY_DP}{this.props.wifiConfigData.wifiGateway}</Text>

        {this.getPageFooter("")}

      </Page >
    );
  }

  // ---------------------- Summary ----------------------------
  createSummaryPage = () => {
    return (
      <Page
        size="A4"
        orientation="portrait"
        wrap={true}
        style={reusableStyles.page}>

        {this.getPageHeader()}

        <Text style={reusableStyles.pageTitle}>{Strings.SUMMARY}</Text>

        <Text style={reusableStyles.summaryText} render={() => (
          `1. ${Strings.LIVE_LIST} ${Strings.LIVE_LIST_DOTS_DP} ${this.state.scopeFirstLiveListPage}`
        )} fixed />

        <Text style={reusableStyles.summaryText} render={() => (
          `2. ${Strings.OSCILLOSCOPE} ${Strings.OSC_DOTS_DP} ${this.state.scopeFirstOscilloscopePage}`
        )} fixed />

        <Text style={reusableStyles.summaryText} render={() => (
          `3. ${Strings.BAR_GRAPH} ${Strings.BAR_DOTS_DP} ${this.state.scopeFirstBarGraphPage}`
        )} fixed />

        <Text style={reusableStyles.summaryText} render={() => (
          `4. ${Strings.LOG} ${Strings.LOG_DOTS_DP} ${this.state.scopeFirstLogPage}`
        )} fixed />

        <Text style={reusableStyles.summaryText} render={({ totalPages }) => (
          `5. ${Strings.DISCLAIMER} ${Strings.DISCLAIMER_DOTS_DP} ${totalPages}`
        )} fixed />

        {this.getPageFooter("")}

      </Page>
    );
  }

  // ----------------- Live List -----------------
  createLiveListPages = () => {
    return (
      <Page
        size="A4"
        orientation="landscape"
        wrap={true}
        style={reusableStyles.page}>

        {this.getPageHeader()}

        {this.getLiveListPageTitle()}

        <View style={liveListStyles.table}>
          {this.createLiveListTableHeader()}
          {this.createLiveListTable()}
        </View>

        {this.getPageFooter("scopeLiveList")}

      </Page>
    );
  }

  getLiveListPageTitle = () => {
    return (
      <Text style={liveListStyles.pageTitle} fixed>{Strings.A_LIVE_LIST_PAGE_TITLE}</Text>
    );
  }

  createLiveListTableHeader = () => {
    return (
      <View style={liveListStyles.tableRow} fixed>

        <View style={liveListStyles.addressTableColHeader}>
          <Text style={liveListStyles.tableCellHeader}>{Strings.ADDRESS}</Text>
        </View>

        <View style={liveListStyles.tagTableColHeader}>
          <Text style={liveListStyles.tableCellHeader}>{Strings.TAG}</Text>
        </View>

        <View style={liveListStyles.ampTableColHeader}>
          <Text style={liveListStyles.tableCellHeader}>{Strings.MIN_AMPLITUDE_N}</Text>
        </View>

        <View style={liveListStyles.ampTableColHeader}>
          <Text style={liveListStyles.tableCellHeader}>{Strings.MEAN_AMPLITUDE_N}</Text>
        </View>
        
        <View style={liveListStyles.ampTableColHeader}>
          <Text style={liveListStyles.tableCellHeader}>{Strings.RESPONSE_TIME}</Text>
        </View>

        <View style={liveListStyles.ampTableColHeader}>
          <Text style={liveListStyles.tableCellHeader}>{Strings.MAX_RESPONSE_TIME}</Text>
        </View>

        <View style={liveListStyles.abTableColHeader}>
          <Text style={liveListStyles.tableCellHeader}>{Strings.NOISE}</Text>
        </View>

        <View style={liveListStyles.abTableColHeader}>
          <Text style={liveListStyles.tableCellHeader}>{Strings.A}</Text>
        </View>

        <View style={liveListStyles.abTableColHeader}>
          <Text style={liveListStyles.tableCellHeader}>{Strings.B}</Text>
        </View>

        <View style={liveListStyles.tableStatusColHeader}>
          <Text style={liveListStyles.tableCellHeader}>{Strings.SIGNAL}</Text>
        </View>

      </View>
    );
  }

  createLiveListTable = () => {
    return (
      this.props.livelist.map(device => (
        <View style={liveListStyles.tableRow} key={device.address} wrap={false}>

          <View style={liveListStyles.addressTableCol}>
            <Text style={liveListStyles.tableCell}>{device.address}{UtilsInstance.getMasterSuffix(device.isMaster)}</Text>
          </View>

          <View style={liveListStyles.tagTableCol}>
            <Text style={liveListStyles.tableCell}>{device.tag}</Text>
          </View>

          <View style={liveListStyles.ampTableCol}>
            <Text style={liveListStyles.tableCell}>{this.getAmplitudeMinText(device)}</Text>
          </View>

          <View style={liveListStyles.ampTableCol}>
            <Text style={liveListStyles.tableCell}>{this.getAmplitudeText(device)}</Text>
          </View>

          <View style={liveListStyles.ampTableCol}>
            <Text style={liveListStyles.tableCell}>{this.getResponseTimeValue(device.responseTime)}</Text>
          </View>

          <View style={liveListStyles.ampTableCol}>
            <Text style={liveListStyles.tableCell}>{this.getResponseTimeValue(device.responseTimeMax)}</Text>
          </View>

          <View style={liveListStyles.abTableCol}>
            <Text style={liveListStyles.tableCell}>{this.createNoiseCell(device.noise)}</Text>
          </View>

          <View style={liveListStyles.abTableCol}>
            <Text style={liveListStyles.tableCell}>{this.createWaveStatusCell(device.aOk)}</Text>
          </View>

          <View style={liveListStyles.abTableCol}>
            <Text style={liveListStyles.tableCell}>{this.createWaveStatusCell(device.bOk)}</Text>
          </View>

          {this.createStatusCell(device)}
        </View>
      ))
    );
  }

  createStatusCell = (device) => {
    if (device.status === Constants.GOOD) {
      if (device.hasWaveProblem) {
        return (
          <View style={liveListStyles.okFadedTableStatusCol}>
            <Text style={liveListStyles.tableCell}>
              {Strings.GOOD_STRING}
            </Text>
          </View>
        );
      }
      else {
        return (
          <View style={liveListStyles.okTableStatusCol}>
            <Text style={liveListStyles.tableCell}>
              {Strings.GOOD_STRING}
            </Text>
          </View>
        );
      }
    }
    else if (device.status === Constants.ATTENTION) {
      if (device.hasWaveProblem) {
        return (
          <View style={liveListStyles.attentionFadedTableStatusCol}>
            <Text style={liveListStyles.tableCell}>
              {Strings.ATTENTION_STRING}
            </Text>
          </View>
        );
      }
      else {
        return (
          <View style={liveListStyles.attentionTableStatusCol}>
            <Text style={liveListStyles.tableCell}>
              {Strings.ATTENTION_STRING}
            </Text>
          </View>
        );
      }
    }
    else if (device.status === Constants.BAD) {
      if (device.hasWaveProblem) {
        return (
          <View style={liveListStyles.badFadedTableStatusCol}>
            <Text style={liveListStyles.tableCell}>
              {Strings.BAD_STRING}
            </Text>
          </View>
        );
      }
      else {
        return (
          <View style={liveListStyles.badTableStatusCol}>
            <Text style={liveListStyles.tableCell}>
              {Strings.BAD_STRING}
            </Text>
          </View>
        );
      }
    }
    else {
      return (
        <View style={liveListStyles.unknownTableStatusCol}>
          <Text style={liveListStyles.tableCell}>
            {Strings.UNKNOWN_STRING}
          </Text>
        </View>
      );
    }
  }

  createWaveStatusCell = (isWaveOk) => {
    if (isWaveOk) {
      return <Image src={`${process.env.PUBLIC_URL}/images/circle-check.png`} />;
    }
    else {
      return <Image src={`${process.env.PUBLIC_URL}/images/circle-warning.png`} />;
    }
  }

  createNoiseCell = (withNoise) => {
    if (!withNoise) {
      return <Image src={`${process.env.PUBLIC_URL}/images/circle-check.png`} />;
    }
    else {
      return <Image src={`${process.env.PUBLIC_URL}/images/circle-warning.png`} />;
    }
  }

  // ----------------- Oscilloscope -----------------
  createOscilloscopePages = () => {
    return (
      <Page
        size="A4"
        orientation="portrait"
        wrap={true}
        style={reusableStyles.page}>

        {this.getPageHeader()}
        {this.getOscilloscopePageTitle()}

        {this.createOscilloscopeImages()}

        {this.getPageFooter("scopeOscilloscope")}
      </Page>
    );
  }

  getOscilloscopePageTitle = () => {
    return (
      <Text style={oscilloscopeStyles.pageTitle} fixed>
        {Strings.A_OSCILLOSCOPE_PAGE_TITLE}
      </Text>
    );
  }

  createOscilloscopeImages = () => {
    return (
      this.props.imgURIs.map(data => (
        <View key={data.address} wrap={false}>

          <Text style={reusableStyles.normalText}>
            <Text style={reusableStyles.boldText}>
              {this.getSlaveMasterText(this.props.livelistMap.get(data.address).isMaster)}
            </Text>
            {data.address}
          </Text>

          <Text style={reusableStyles.normalText}>
            <Text style={reusableStyles.boldText}>
              {Strings.SIGNAL_DP}
            </Text>
            {this.getStatusText(this.props.livelistMap.get(data.address).status)}
          </Text>

          <Text style={reusableStyles.normalText}>
            <Text style={reusableStyles.boldText}>
              {Strings.AMPLITUDE_MIN_DP}
            </Text>
            {this.getAmplitudeMinText(this.props.livelistMap.get(data.address))}
          </Text>

          <Text style={reusableStyles.normalText}>
            <Text style={reusableStyles.boldText}>
              {Strings.MEAN_AMPLITUDE}:
            </Text>
            {" " + this.getAmplitudeText(this.props.livelistMap.get(data.address))}
          </Text>

          <Text style={reusableStyles.normalText}>
            <Text style={reusableStyles.boldText}>
              {Strings.CAPTURE_TIME}:
            </Text>
            {" " + data.time}
          </Text>

          <Text style={oscilloscopeStyles.waveTitle}>{Strings.B_A}</Text>

          <Image src={data.waveBA.imgURI} style={oscilloscopeStyles.chartImgStyle} />

          <Text style={oscilloscopeStyles.waveTitle}>{Strings.A_AND_B}</Text>

          <Image src={data.waveAB.imgURI} style={oscilloscopeStyles.chartImgStyle} />

        </View>
      ))
    );
  }

  // ----------------- Bar Graph -----------------
  createBarGraphPages = () => {
    return (
      <Page
        size="A4"
        orientation="portrait"
        wrap={true}
        style={reusableStyles.page}>

        {this.getPageHeader()}
        {this.getBarGraphPageTitle()}

        <Text style={ampStyles.waveTitle}>{Strings.MIN_AMPLITUDE}</Text>
        {this.createBarGraphMinImages()}

        <Text style={ampStyles.waveTitle}>{Strings.MEAN_AMPLITUDE}</Text>
        {this.createBarGraphAmpImages()}

        {this.getPageFooter("scopeBarGraph")}
      </Page>
    );
  }

  getBarGraphPageTitle = () => {
    return <Text style={ampStyles.pageTitle} fixed>{Strings.A_BAR_GRAPH_PAGE_TITLE}</Text>;
  }

  createBarGraphAmpImages = () => {
    return (
      this.props.ampImgURIs.map(data => (
        // eslint-disable-next-line react/jsx-key
        <Image src={data.imgURI} style={ampStyles.chartImgStyle} />
      ))
    );
  }

  createBarGraphMinImages = () => {
    return (
      this.props.minAmpImgURIs.map(data => (
        // eslint-disable-next-line react/jsx-key
        <Image src={data.imgURI} style={ampStyles.chartImgStyle} />
      ))
    );
  }

  // ----------------- Log -----------------
  createMonitoringLogPages = () => {
    return (
      <Page
        size="A4"
        orientation="portrait"
        wrap={true}
        style={reusableStyles.page}>

        {this.getPageHeader()}

        <Text style={monitoringLogStyles.pageTitle} fixed>{Strings.A_LOG_PAGE_TITLE}</Text>
        <Text style={monitoringLogStyles.pageLastEventsText} fixed>{Strings.LAST_200_EVENTS}</Text>

        <View style={monitoringLogStyles.table}>
          {this.createMonitoringLogTableHeader()}
          {this.createMonitoringLogTable()}
        </View>

        {this.getPageFooter("scopeLog")}

      </Page>
    );
  }

  createMonitoringLogTableHeader = () => {
    return (
      <View style={monitoringLogStyles.tableRow} fixed>

        <View style={monitoringLogStyles.horaryTableColHeader}>
          <Text style={monitoringLogStyles.tableCellHeader}>{Strings.HORARY}</Text>
        </View>

        <View style={monitoringLogStyles.typeTableColHeader}>
          <Text style={monitoringLogStyles.tableCellHeader}>{Strings.TYPE}</Text>
        </View>

        <View style={monitoringLogStyles.descriptionTableColHeader}>
          <Text style={monitoringLogStyles.tableCellHeader}>{Strings.DESCRIPTION}</Text>
        </View>

      </View>
    );
  }

  createMonitoringLogTable = () => {
    return (
      this.props.log.map(logEntry => (
        <View wrap={false} key={logEntry.event}>
          <View style={monitoringLogStyles.tableRow} key={logEntry.event}>

            <View style={monitoringLogStyles.horaryTableCol}>
              <Text style={monitoringLogStyles.tableCell}>{this.formatTime(logEntry)}</Text>
            </View>

            <View style={monitoringLogStyles.typeTableCol}>
              <Text style={monitoringLogStyles.tableCell}>{this.getTypeText(logEntry.type)}</Text>
            </View>

            <View style={monitoringLogStyles.descriptionTableCol}>
              <Text style={monitoringLogStyles.tableCell}>
                {this.getDescriptionText(logEntry.type, logEntry.active)}
              </Text>
            </View>
          </View>
        </View>
      ))
    );
  }

  getTypeText = (problemType) => {
    if (problemType === Constants.TERMINATION_OFF_PROBLEM_TYPE) {
      return Strings.TERMINATION_OFF_LIST_HEADER;
    }
    else if (problemType === Constants.NO_POWER_SUPPLY_PROBLEM_TYPE) {
      return Strings.NO_POWER_SUPPLY_LIST_HEADER;
    }
    else if (problemType === Constants.HIGH_RESISTANCE_PROBLEM_TYPE) {
      return Strings.HIGH_RESISTANCE_LIST_HEADER;
    }
    else if (problemType === Constants.A_NOT_OK_PROBLEM_TYPE) {
      return Strings.A_NOT_OK_LIST_HEADER;
    }
    else if (problemType === Constants.B_NOT_OK_PROBLEM_TYPE) {
      return Strings.B_NOT_OK_LIST_HEADER;
    }
    else if (problemType === Constants.LONG_CABLE_PROBLEM_TYPE) {
      return Strings.LONG_CABLE_LIST_HEADER;
    }
    else if (problemType === Constants.NOISE_PROBLEM_TYPE) {
      return Strings.NOISE_LIST_HEADER;
    }
    else if (problemType === Constants.REFLECTION_PROBLEM_TYPE) {
      return Strings.REFLECTION_LIST_HEADER;
    }
    else {
      return Strings.UNKNOWN;
    }
  }

  getDescriptionText = (problemType, isActive) => {
    if (problemType === Constants.TERMINATION_OFF_PROBLEM_TYPE) {
      return isActive ? Strings.TERMINATION_OFF_LOG_DESCRIPTION : Strings.EVENT_CHECKED_SUCCESS;
    }
    else if (problemType === Constants.NO_POWER_SUPPLY_PROBLEM_TYPE) {
      return isActive ? Strings.NO_POWER_SUPPLY_LOG_DESCRIPTION : Strings.EVENT_CHECKED_SUCCESS;
    }
    else if (problemType === Constants.HIGH_RESISTANCE_PROBLEM_TYPE) {
      return isActive ? Strings.HIGH_RESISTANCE_LOG_DESCRIPTION : Strings.EVENT_CHECKED_SUCCESS;
    }
    else if (problemType === Constants.A_NOT_OK_PROBLEM_TYPE) {
      return isActive ? Strings.A_NOT_OK_LOG_DESCRIPTION : Strings.EVENT_CHECKED_SUCCESS;
    }
    else if (problemType === Constants.B_NOT_OK_PROBLEM_TYPE) {
      return isActive ? Strings.B_NOT_OK_LOG_DESCRIPTION : Strings.EVENT_CHECKED_SUCCESS;
    }
    else if (problemType === Constants.LONG_CABLE_PROBLEM_TYPE) {
      return isActive ? Strings.LONG_CABLE_LOG_DESCRIPTION : Strings.EVENT_CHECKED_SUCCESS;
    }
    else if (problemType === Constants.NOISE_PROBLEM_TYPE) {
      return isActive ? Strings.NOISE_LOG_DESCRIPTION : Strings.EVENT_CHECKED_SUCCESS;
    }
    else if (problemType === Constants.REFLECTION_PROBLEM_TYPE) {
      return isActive ? Strings.REFLECTION_LOG_DESCRIPTION : Strings.EVENT_CHECKED_SUCCESS;
    }
  }

  formatTime = (logEntry) => {
    if (logEntry.ntp !== null && logEntry.ntp === true) {
      let parsedMillis = Date.parse(logEntry.time);
      let dateToShow = new Date(parsedMillis);
      return dateToShow.toLocaleString("pt-BR");
    }
    else if (logEntry.time !== undefined && logEntry.time !== null) {
      let timeNow = new Date().getTime();
      const eventTimeInMillis = logEntry.time * 1000;
      const time = timeNow - eventTimeInMillis;
      const dateToShow = new Date(time);
      return (dateToShow.toLocaleString("pt-BR"));
    }
    else {
      return Strings.BEFORE_MONITOR_INIT_STR;
    }
  }

  // ----------------- Disclaimer -----------------
  createDisclaimerPage() {
    return (
      <Page
        size="A4"
        orientation="portrait"
        wrap={true}
        style={reusableStyles.page}>

        {this.getPageHeader()}

        <View style={{ marginTop: "30vh" }} />

        <Text style={reusableStyles.pageTitle}>{Strings.END_OF_REPORT}</Text>

        <View style={{ marginTop: "25vh" }} />

        <Text style={{
          fontSize: 14,
          fontFamily: "RobotoMedium",
          marginBottom: "5px"
        }}>
          {Strings.DISCLAIMER}
        </Text>

        <View style={reusableStyles.subHeaderLine} />

        <Text
          style={{
            fontSize: 12,
            marginBottom: 2,
            fontFamily: "RobotoRegular",
            textAlign: "justify"
          }}>
          {Strings.DISCLAIMER_TEXT}
        </Text>

        {this.getPageFooter("")}

      </Page >
    );
  }

  render() {
    return (
      this.createReport()
    );
  }
}

const reusableStyles = StyleSheet.create({
  page: {
    paddingTop: 16,
    paddingHorizontal: 40,
    paddingBottom: 56
  },

  pageTitle: {
    textAlign: "center",
    fontSize: 18,
    marginTop: "2vh",
    marginBottom: "4vh",
    fontWeight: "bold",
    fontFamily: "RobotoMedium"
  },

  subHeaderText: {
    fontSize: 12,
    fontFamily: "RobotoMedium"
  },

  secondSubHeaderText: {
    marginTop: "3vh",
    fontSize: 12,
    fontFamily: "RobotoMedium"
  },

  subHeaderLine: {
    height: "1px",
    backgroundColor: "black",
    marginTop: "0.5vh",
    marginBottom: "2vh"
  },

  normalText: {
    fontSize: 12,
    marginBottom: 2,
    fontFamily: "RobotoRegular"
  },

  boldText: {
    fontSize: 12,
    marginBottom: 2,
    fontWeight: "bold",
    fontFamily: "RobotoMedium"
  },

  lastInfoText: {
    fontSize: 12,
    marginBottom: "2vh",
    fontFamily: "RobotoRegular"
  },

  summaryText: {
    fontSize: 12,
    marginBottom: "1vh",
    fontFamily: "RobotoRegular"
  },
});

const headerStyles = StyleSheet.create({
  container: {
    display: "inline-flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center"
  },

  logo: {
    width: "92pt",
    height: "30pt",
    marginBottom: "6pt"
  },

  text: {
    fontSize: 12,
    fontFamily: "RobotoMedium"
  },

  line: {
    height: "1px",
    backgroundColor: "black",
    marginTop: "1vh",
    marginBottom: "2vh"
  }
});

const footerStyles = StyleSheet.create({
  container: {
    textAlign: "right",
    position: "absolute",
    bottom: 20,
    left: 40,
    right: 40
  },

  line: {
    height: "1px",
    backgroundColor: "black",
    marginTop: "1vh",
    marginBottom: "1vh"
  },

  text: {
    fontSize: 12,
    fontFamily: "RobotoRegular"
  }
});

const generalInfoStyles = StyleSheet.create({

  notesSection: {
    maxWidth: "510pt",
    width: "90vw",
    height: "14vh"
  },

  conclusionSection: {
    display: "inline-flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    height: "16vh"
  },

  rectangleSection: {
    display: "inline-flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "center"
  },

  rectangle: {
    width: 28,
    height: 28,
    margin: "1vh vw"
  },
  signatureLine: {
    height: "1px",
    width: "40vw",
    backgroundColor: "black",
  }
});

const liveListStyles = StyleSheet.create({
  pageTitle: {
    fontSize: 18,
    marginTop: "2vh",
    marginBottom: "4vh",
    fontFamily: "RobotoMedium"
  },

  table: {
    display: "table",
    width: "auto"
  },

  tableRow: {
    flexDirection: "row"
  },

  addressTableColHeader: {
    width: "10%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    backgroundColor: "#bdbdbd"
  },

  tagTableColHeader: {
    width: "15%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  abTableColHeader: {
    width: "7%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  ampTableColHeader: {
    width: "11%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  tableStatusColHeader: {
    width: "10%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  addressTableCol: {
    width: "10%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderTopWidth: 0
  },

  tagTableCol: {
    width: "15%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  abTableCol: {
    width: "7%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  ampTableCol: {
    width: "11%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  okTableStatusCol: {
    width: "10%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    backgroundColor: "lime"
  },

  attentionTableStatusCol: {
    width: "10%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    backgroundColor: "yellow"
  },

  badTableStatusCol: {
    width: "10%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    backgroundColor: "#FF5722"
  },

  okFadedTableStatusCol: {
    width: "10%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    backgroundColor: "lime",
    opacity: 0.5
  },

  attentionFadedTableStatusCol: {
    width: "10%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    backgroundColor: "yellow",
    opacity: 0.5
  },

  badFadedTableStatusCol: {
    width: "10%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    backgroundColor: "#FF5722",
    opacity: 0.5
  },

  unknownTableStatusCol: {
    width: "10%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    backgroundColor: "lightgrey"
  },

  tableCellHeader: {
    textAlign: "center",
    margin: 4,
    fontSize: 10,
    fontFamily: "RobotoMedium"
  },

  tableCell: {
    textAlign: "center",
    margin: 5,
    fontSize: 10,
    fontFamily: "RobotoRegular"
  }
});

const oscilloscopeStyles = StyleSheet.create({
  pageTitle: {
    fontSize: 18,
    marginTop: "2vh",
    marginBottom: "4vh",
    fontFamily: "RobotoMedium"
  },

  waveTitle: {
    textAlign: "center",
    fontFamily: "RobotoMedium",
    fontSize: 16,
    marginTop: "1vh",
    marginBottom: "1vh"
  },

  chartImgStyle: {

    height: "28vh",
    width: "87vw"
  }
});

const ampStyles = StyleSheet.create({
  pageTitle: {
    fontSize: 18,
    marginTop: "2vh",
    marginBottom: "4vh",
    fontFamily: "RobotoMedium"
  },

  waveTitle: {
    textAlign: "center",
    fontFamily: "RobotoMedium",
    fontSize: 16
  },

  chartImgStyle: {
    height: "33vh",
    width: "87vw",
    marginTop: "1vh",
    marginBottom: "4vh"
  }
});

const monitoringLogStyles = StyleSheet.create({
  pageTitle: {
    fontSize: 18,
    marginTop: "2vh",
    fontFamily: "RobotoMedium"
  },

  pageLastEventsText: {
    fontSize: 12,
    marginBottom: "3vh",
    fontFamily: "RobotoRegular"
  },

  table: {
    display: "table",
    width: "auto"
  },

  tableRow: {
    flexDirection: "row"
  },

  horaryTableColHeader: {
    width: "20%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    bortderTopWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  typeTableColHeader: {
    width: "30%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    bortderTopWidth: 0,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  descriptionTableColHeader: {
    width: "50%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    bortderTopWidth: 0,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  tableCellHeader: {
    textAlign: "center",
    margin: 4,
    fontSize: 8,
    fontWeight: "bold",
    fontFamily: "RobotoMedium"
  },

  horaryTableCol: {
    width: "20%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderTopWidth: 0
  },

  typeTableCol: {
    width: "30%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  descriptionTableCol: {
    width: "50%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  tableCell: {
    textAlign: "center",
    margin: 4,
    fontSize: 8,
    fontFamily: "RobotoRegular"
  },

  tableCellLeft: {
    textAlign: "left",
    margin: 4,
    fontSize: 8,
    fontFamily: "RobotoRegular"
  },
});

export default AnalyzerDPReport;
